import React from 'react';

import emotionStyled from '@emotion/styled';
import { Grid, Paper } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
// import logo from "assets/images/logo@2x.png";
import SearchContainer from 'screens/home/search/SearchContainer';
import styled from 'styled-components';
import { MaxWidthCSS, StyledGrid } from 'styles/common';
import { checkVisierAnalyticsEnabled } from 'utils/helpers/featureFlags';

import { MeshLogoWithName } from 'assets/assetsV1/iconComponents';

import { isMobileView } from 'constants/isMobileView';
import { routes } from 'constants/routes';

import HeaderActions from './HeaderActions';
import MobileSiteHeaderActions from './MobileSiteHeaderActions';

function Header(props) {
  function goToHome() {
    props.history.push(routes.home);
  }

  if (isMobileView()) {
    return (
      <Container>
        <StyledGrid item sm={8} md={7}>
          <MobileSiteHeaderActions />
        </StyledGrid>
      </Container>
    );
  }
  return (
    <Container>
      <MaxWidthContainer>
        <FullHeightStyledGrid container>
          <CenterAlignedGrid item sm={1}>
            <LogoContainer onClick={goToHome}>
              <MeshLogoWithName boxSize="105px" />
            </LogoContainer>
          </CenterAlignedGrid>
          <StyledGrid item sm={3} md={4}>
            <SearchWrapper>
              <SearchContainer />
            </SearchWrapper>
          </StyledGrid>
          <StyledGrid item sm={8} md={checkVisierAnalyticsEnabled() ? 8 : 7}>
            <HeaderActions />
          </StyledGrid>
        </FullHeightStyledGrid>
      </MaxWidthContainer>
    </Container>
  );
}

export default withRouter(Header);
const Container = emotionStyled(Paper)`
  height: 92px;
  position: fixed;
  left: 0;
  width: 100%;
  top: 0;
  z-index: 950;
  border-radius: 0;
  box-shadow: 0px 1px 0px ${(props) => props.theme.colors.neutral.CFD7DF};
`;

const MaxWidthContainer = styled.div`
  ${MaxWidthCSS}
  display: flex;
  align-items: center;
  height: 100%;
`;

const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    height: 100%;
    cursor: pointer;
  }
  margin-right: 1.5rem;
`;

const SearchWrapper = styled.div`
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  & div {
    cursor: text;
  }
`;

const CenterAlignedGrid = styled(Grid)`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const FullHeightStyledGrid = styled(Grid)`
  height: 100%;
  flex-wrap: nowrap;
`;
